export enum EErrorType {
	PRODUCT_NO_PRICE = 'productNoPrice'
}
